export enum CartTypes {
    OrderCart = 1
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/cart-type.enum.ts